module.exports = __webpack_public_path__ + "static/media/place.18e445e0.svg";